import { useState, useEffect } from 'react';

export const useBexioData = (wsProvider) => {
    const [bexioData, setBexioData] = useState(null);

    useEffect(() => {
        const loadBexioData = () => {
            const data = wsProvider.getFileFromBackend('BexioFlatListExport', []);
            if (data && data !== "loading...") {
                setBexioData(data);
            }
        };

        // Try to load immediately
        loadBexioData();

        // Set up polling to check when data is loaded
        const interval = setInterval(() => {
            const data = wsProvider.getFileFromBackend('BexioFlatListExport', []);
            if (data && data !== "loading...") {
                setBexioData(data);
                clearInterval(interval);
            }
        }, 100);

        return () => clearInterval(interval);
    }, [wsProvider, wsProvider.clientSelected]);

    return bexioData;
}; 